export class SolComponentsService {
  constructor(public readonly version: string) {}
}
